var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AxiosError } from 'axios';
import React, { useState } from 'react';
import { mapRoleIdToRoleName } from '../../../common/constants';
import { ApiI18, getResponseErrorMessage } from '../../../network/api';
import { FlexContainer, FormContainer, RightComponent, InputContainer } from '../../../styles/generalStyles';
import { TitleForm } from '../../../styles/variables/text.styles';
import { Button } from '../../_common/button/button.styles';
import Input from '../../_common/input/input';
import LangMessage from '../../_common/lang/message';
var FormLogin = function (_a) {
    var handleFormChangeAnimate = _a.handleFormChangeAnimate, showFormRegistration = _a.showFormRegistration;
    var _b = useState(''), email = _b[0], setEmail = _b[1];
    var _c = useState(''), password = _c[0], setPassword = _c[1];
    var _d = useState(''), emailError = _d[0], setEmailError = _d[1];
    var _e = useState(''), errorMessage = _e[0], setErrorMessage = _e[1];
    var validateEmail = function (value) {
        if (!value || /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,64}$/i.test(value)) {
            setEmailError('');
        }
        else {
            setEmailError('CustDashboard.invalidEmailAddress');
        }
    };
    /* eslint-disable @typescript-eslint/no-unused-vars */
    var _f = useState({
        code: 0,
        payload: {},
    }), loggedInUser = _f[0], setLogin = _f[1];
    var handleLogin = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var response, res, currentAppVersion, error_1, message;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, ApiI18.fetchLogin(data)];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, ApiI18.getSettingByParams({ _id: 'updateWeb' })];
                case 2:
                    res = _b.sent();
                    if (response.status >= 200 && response.status < 300) {
                        setLogin(response.data.payload.data);
                        currentAppVersion = ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.payload) || '0.0.1';
                        localStorage.setItem('appVersion', currentAppVersion);
                        localStorage.setItem('Authorization_gad24', "Bearer ".concat(response.data.payload.access.token));
                        localStorage.setItem('RefreshToken', "".concat(response.data.payload.refresh.token));
                        localStorage.setItem('userData', JSON.stringify(response.data.payload.data));
                        localStorage.setItem('role', mapRoleIdToRoleName(response.data.payload.data.role));
                        window.location.href = '/';
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    if (error_1 instanceof AxiosError) {
                        message = getResponseErrorMessage(error_1);
                        setErrorMessage(message);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleEmailBlur = function () {
        validateEmail(email);
    };
    var handleEmailInputChange = function (e) {
        var inputValue = e.target.value;
        setEmail(inputValue);
        setErrorMessage('');
        if (!inputValue) {
            setEmailError('');
        }
    };
    var handlePasswordInputChange = function (e) {
        setPassword(e.target.value);
    };
    var formLoginData = [
        {
            errorMessage: emailError,
            errorMessageWithoutTrans: errorMessage,
            handleClearInput: function () { setEmail(''); setEmailError(''); setErrorMessage(''); },
            id: 'username',
            name: 'username',
            onBlur: handleEmailBlur,
            onChange: handleEmailInputChange,
            placeholder: 'form.email',
            require: true,
            required: false,
            type: 'email',
            value: email,
        },
        {
            autoComplete: "password",
            handleClearInput: function () { return setPassword(''); },
            id: 'password',
            name: 'password',
            onChange: handlePasswordInputChange,
            placeholder: 'form.password',
            require: true,
            required: false,
            type: 'password',
            value: password,
        }
    ];
    var handleKeyDown = function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (email && password) {
                if (!emailError && email && password) {
                    handleLogin({ email: email, password: password });
                }
            }
        }
    };
    return (_jsx("form", __assign({ onKeyDown: handleKeyDown }, { children: _jsxs(FormContainer, { children: [_jsx(TitleForm, { children: _jsx(LangMessage, { msgKey: 'formSingIn.title', defaultValue: 'Customer Login' }) }), formLoginData.map(function (field, index) { return (_jsx(InputContainer, { children: _jsx(Input, __assign({}, field)) }, index)); }), _jsx(RightComponent, __assign({ "$paddingTop": '10px', "$paddingBottom": '30px' }, { children: _jsx(Button, __assign({ "$borderColour": 'transp', type: 'button', onClick: function () { return handleFormChangeAnimate && handleFormChangeAnimate('forgotPassword'); } }, { children: _jsx(LangMessage, { msgKey: 'form.forgotPassword', defaultValue: 'Forgot password?' }) })) })), _jsxs(FlexContainer, { children: [_jsx(Button, __assign({ "$size": 'small', "$borderColour": 'blue', type: 'button', onClick: showFormRegistration }, { children: _jsx(LangMessage, { msgKey: 'form.ImNewHere', defaultValue: "I'm new here" }) })), _jsx(Button, __assign({ "$size": 'small', "$bgColour": 'blue', type: 'button', onClick: function () {
                                if (!emailError && email && password) {
                                    handleLogin({ email: email, password: password });
                                }
                            } }, { children: _jsx(LangMessage, { msgKey: 'form.login', defaultValue: 'login' }) }))] })] }) })));
};
export default FormLogin;
